!(function (e, t) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = t(
        require("react"),
        require("react-dom"),
        require("react-dom/server"),
      ))
    : "function" == typeof define && define.amd
    ? define(["react", "react-dom", "react-dom/server"], t)
    : "object" == typeof exports
    ? (exports.ReactRailsUJS = t(
        require("react"),
        require("react-dom"),
        require("react-dom/server"),
      ))
    : (e.ReactRailsUJS = t(e.React, e.ReactDOM, e.ReactDOMServer))
})(
  self,
  (
    __WEBPACK_EXTERNAL_MODULE__787__,
    __WEBPACK_EXTERNAL_MODULE__156__,
    __WEBPACK_EXTERNAL_MODULE__997__,
  ) =>
    (() => {
      var __webpack_modules__ = {
          634: (e, t, n) => {
            "use strict"
            var o = n(156)
            ;(t.createRoot = o.createRoot), (t.hydrateRoot = o.hydrateRoot)
          },
          10: (e, t, n) => {
            var o = n(787),
              r = n(156),
              a = n(997),
              u = n(230),
              c = n(121),
              i = n(831),
              d = n(37),
              s = n(39),
              {
                supportsHydration: _,
                reactHydrate: l,
                createReactRootLike: p,
              } = n(198),
              f = n(613),
              v = {
                CLASS_NAME_ATTR: "data-react-class",
                PROPS_ATTR: "data-react-props",
                RENDER_ATTR: "data-hydrate",
                CACHE_ID_ATTR: "data-react-cache-id",
                TURBOLINKS_PERMANENT_ATTR: "data-turbolinks-permanent",
                jQuery:
                  "undefined" != typeof window &&
                  void 0 !== window.jQuery &&
                  window.jQuery,
                components: {},
                roots: [],
                findDOMNodes: function (e) {
                  var t,
                    n,
                    o = v.CLASS_NAME_ATTR
                  switch (typeof e) {
                    case "undefined":
                      ;(t = "[" + o + "]"), (n = document)
                      break
                    case "object":
                      ;(t = "[" + o + "]"), (n = e)
                      break
                    case "string":
                      ;(t = e + "[" + o + "], " + e + " [" + o + "]"),
                        (n = document)
                  }
                  return v.jQuery ? v.jQuery(t, n) : n.querySelectorAll(t)
                },
                getConstructor: c,
                constructorFromGlobal: c,
                constructorFromRequireContext: i,
                constructorFromRequireContextWithGlobalFallback: d,
                useContext: function (e) {
                  this.getConstructor = d(e)
                },
                useContexts: function (e) {
                  this.getConstructor = s(e)
                },
                serverRender: function (e, t, n) {
                  var r = this.getConstructor(t),
                    u = o.createElement(r, n)
                  return a[e](u)
                },
                mountComponents: function (e) {
                  for (
                    var t = v, n = t.findDOMNodes(e), r = 0;
                    r < n.length;
                    ++r
                  ) {
                    var a = n[r],
                      u = a.getAttribute(t.CLASS_NAME_ATTR),
                      c = t.getConstructor(u),
                      i = a.getAttribute(t.PROPS_ATTR),
                      d = i && JSON.parse(i),
                      s = a.getAttribute(t.RENDER_ATTR),
                      p = a.getAttribute(t.CACHE_ID_ATTR),
                      f = a.hasAttribute(t.TURBOLINKS_PERMANENT_ATTR)
                    if (!c) {
                      var E = "Cannot find component: '" + u + "'"
                      throw (
                        (console &&
                          console.log &&
                          console.log(
                            "%c[react-rails] %c" + E + " for element",
                            "font-weight: bold",
                            "",
                            a,
                          ),
                        new Error(
                          E +
                            ". Make sure your component is available to render.",
                        ))
                      )
                    }
                    var h = this.components[p]
                    void 0 === h &&
                      ((h = o.createElement(c, d)),
                      f && (this.components[p] = h)),
                      (h =
                        s && _() ? l(a, h) : this.findOrCreateRoot(a).render(h))
                  }
                },
                unmountComponents: function (e) {
                  for (var t = v.findDOMNodes(e), n = 0; n < t.length; ++n) {
                    var o = t[n]
                    f ? this.unmountRoot(o) : r.unmountComponentAtNode(o)
                  }
                },
                detectEvents: function () {
                  u(this)
                },
                findOrCreateRoot: function (e) {
                  var t = this.findRoot(e)
                  return (
                    t ||
                      ((t = p(e)), f && this.roots.push({ node: e, root: t })),
                    t
                  )
                },
                findRoot: function (e) {
                  if (f) {
                    var t = this.roots.find(function (t) {
                      return t.node && t.node === e
                    })
                    return t ? t.root : void 0
                  }
                },
                unmountRoot: function (e) {
                  var t = this.findRoot(e)
                  t &&
                    (t.unmount(),
                    (this.roots = this.roots.filter(function (t) {
                      return t.node !== e
                    })))
                },
                handleMount: function (e) {
                  var t = void 0
                  e && e.target && (t = e.target), v.mountComponents(t)
                },
                handleUnmount: function (e) {
                  var t = void 0
                  e && e.target && (t = e.target), v.unmountComponents(t)
                },
              }
            "undefined" != typeof window && v.detectEvents(),
              (self.ReactRailsUJS = v),
              (e.exports = v)
          },
          230: (e, t, n) => {
            var o = n(528),
              r = n(921),
              a = n(228),
              u = n(724),
              c = n(968)
            e.exports = function (e) {
              e.handleEvent &&
                ("undefined" != typeof Turbolinks &&
                  void 0 !== Turbolinks.EVENTS &&
                  c.teardown(e),
                a.teardown(e),
                u.teardown(e),
                r.teardown(e),
                o.teardown(e)),
                "addEventListener" in window
                  ? ((e.handleEvent = function (e, t) {
                      document.addEventListener(e, t)
                    }),
                    (e.removeEvent = function (e, t) {
                      document.removeEventListener(e, t)
                    }))
                  : ((e.handleEvent = function (e, t) {
                      window.attachEvent(e, t)
                    }),
                    (e.removeEvent = function (e, t) {
                      window.detachEvent(e, t)
                    })),
                "undefined" != typeof Turbolinks && Turbolinks.supported
                  ? void 0 !== Turbolinks.EVENTS
                    ? c.setup(e)
                    : void 0 !== Turbolinks.controller
                    ? a.setup(e)
                    : u.setup(e)
                  : "undefined" != typeof $ && "function" == typeof $.pjax
                  ? r.setup(e)
                  : o.setup(e)
            }
          },
          528: (e) => {
            e.exports = {
              setup: function (e) {
                "addEventListener" in window
                  ? e.handleEvent("DOMContentLoaded", e.handleMount)
                  : e.handleEvent("onload", e.handleMount)
              },
              teardown: function (e) {
                e.removeEvent("DOMContentLoaded", e.handleMount),
                  e.removeEvent("onload", e.handleMount)
              },
            }
          },
          921: (e) => {
            e.exports = {
              setup: function (e) {
                e.handleEvent("ready", e.handleMount),
                  e.handleEvent("pjax:end", e.handleMount),
                  e.handleEvent("pjax:beforeReplace", e.handleUnmount)
              },
              teardown: function (e) {
                e.removeEvent("ready", e.handleMount),
                  e.removeEvent("pjax:end", e.handleMount),
                  e.removeEvent("pjax:beforeReplace", e.handleUnmount)
              },
            }
          },
          228: (e) => {
            e.exports = {
              setup: function (e) {
                e.handleEvent("turbolinks:load", e.handleMount)
              },
              teardown: function (e) {
                e.removeEvent("turbolinks:load", e.handleMount)
              },
            }
          },
          968: (e) => {
            e.exports = {
              setup: function (e) {
                e.handleEvent(Turbolinks.EVENTS.CHANGE, e.handleMount),
                  e.handleEvent(
                    Turbolinks.EVENTS.BEFORE_UNLOAD,
                    e.handleUnmount,
                  )
              },
              teardown: function (e) {
                e.removeEvent(Turbolinks.EVENTS.CHANGE, e.handleMount),
                  e.removeEvent(
                    Turbolinks.EVENTS.BEFORE_UNLOAD,
                    e.handleUnmount,
                  )
              },
            }
          },
          724: (e) => {
            e.exports = {
              setup: function (e) {
                Turbolinks.pagesCached(0),
                  e.handleEvent("page:change", e.handleMount),
                  e.handleEvent("page:receive", e.handleUnmount)
              },
              teardown: function (e) {
                e.removeEvent("page:change", e.handleMount),
                  e.removeEvent("page:receive", e.handleUnmount)
              },
            }
          },
          121: function (module) {
            var topLevel = "undefined" == typeof window ? this : window
            module.exports = function (className) {
              var constructor
              return (
                (constructor = topLevel[className]),
                constructor || (constructor = eval(className)),
                constructor &&
                  constructor.default &&
                  (constructor = constructor.default),
                constructor
              )
            }
          },
          831: (e) => {
            e.exports = function (e) {
              return function (t) {
                var n = t.split("."),
                  o = n.shift(),
                  r = n,
                  a = e("./" + o)
                return (
                  r.forEach(function (e) {
                    a = a[e]
                  }),
                  a.__esModule && (a = a.default),
                  a
                )
              }
            }
          },
          37: (e, t, n) => {
            var o = n(121),
              r = n(831)
            e.exports = function (e) {
              var t = r(e)
              return function (e) {
                var n
                try {
                  n = t(e)
                } catch (t) {
                  try {
                    n = o(e)
                  } catch (e) {
                    console.error(t), console.error(e)
                  }
                }
                return n
              }
            }
          },
          39: (e, t, n) => {
            var o = n(121),
              r = n(831)
            e.exports = function (e) {
              var t = e.map((e) => r(e))
              return function (e) {
                var n
                try {
                  var r,
                    a,
                    u = 0
                  do {
                    r = t[u]
                    try {
                      n = r(e)
                    } catch (e) {
                      a || (a = e)
                    }
                    u += 1
                  } while (u < t.length)
                  if (!n) throw a
                } catch (a) {
                  try {
                    n = o(e)
                  } catch (e) {
                    console.error(a), console.error(e)
                  }
                }
                return n
              }
            }
          },
          198: (e, t, n) => {
            "use strict"
            n.r(t),
              n.d(t, {
                createReactRootLike: () => _,
                reactHydrate: () => s,
                supportsHydration: () => d,
              })
            var o = n(156),
              r = n.n(o),
              a = n(613),
              u = n.n(a)
            let c = r()
            if (u())
              try {
                c = n(634)
              } catch (e) {
                c = r()
              }
            const i = c
            function d() {
              return (
                "function" == typeof i.hydrate ||
                "function" == typeof i.hydrateRoot
              )
            }
            function s(e, t) {
              return "function" == typeof i.hydrateRoot
                ? i.hydrateRoot(e, t)
                : i.hydrate(t, e)
            }
            function _(e) {
              return u()
                ? i.createRoot(e)
                : (function (e) {
                    return { render: (t) => i.render(t, e) }
                  })(e)
            }
          },
          613: (e, t, n) => {
            var o,
              r = n(156)
            ;(o = void 0 !== r && (r.version.split(".")[0] || 16) >= 18),
              (e.exports = o)
          },
          787: (e) => {
            "use strict"
            e.exports = __WEBPACK_EXTERNAL_MODULE__787__
          },
          156: (e) => {
            "use strict"
            e.exports = __WEBPACK_EXTERNAL_MODULE__156__
          },
          997: (e) => {
            "use strict"
            e.exports = __WEBPACK_EXTERNAL_MODULE__997__
          },
        },
        __webpack_module_cache__ = {}
      function __webpack_require__(e) {
        var t = __webpack_module_cache__[e]
        if (void 0 !== t) return t.exports
        var n = (__webpack_module_cache__[e] = { exports: {} })
        return (
          __webpack_modules__[e].call(
            n.exports,
            n,
            n.exports,
            __webpack_require__,
          ),
          n.exports
        )
      }
      ;(__webpack_require__.n = (e) => {
        var t = e && e.__esModule ? () => e.default : () => e
        return __webpack_require__.d(t, { a: t }), t
      }),
        (__webpack_require__.d = (e, t) => {
          for (var n in t)
            __webpack_require__.o(t, n) &&
              !__webpack_require__.o(e, n) &&
              Object.defineProperty(e, n, { enumerable: !0, get: t[n] })
        }),
        (__webpack_require__.o = (e, t) =>
          Object.prototype.hasOwnProperty.call(e, t)),
        (__webpack_require__.r = (e) => {
          "undefined" != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
            Object.defineProperty(e, "__esModule", { value: !0 })
        })
      var __webpack_exports__ = __webpack_require__(10)
      return __webpack_exports__
    })(),
)
